import { z } from 'zod';
import { orgRoleSchema } from './permissions';

/** A row of `list_org_members`: names are null for someone who signed up without them. */
export const orgMemberSchema = z.object({
  user_id: z.uuid(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  email: z.string(),
  role: orgRoleSchema,
  joined_at: z.iso.datetime({ offset: true }),
});
export type OrgMember = z.infer<typeof orgMemberSchema>;

/** "Ada Lovelace", or the email for a member without a profile. */
export function memberDisplayName(member: Pick<OrgMember, 'first_name' | 'last_name' | 'email'>) {
  return member.first_name && member.last_name
    ? `${member.first_name} ${member.last_name}`
    : member.email;
}
